import "regenerator-runtime/runtime";
import * as skyway from "../../lib/skyway.js";

// 通話機能のセットアップ関数。Railsのビューから呼び出す。
//   - config.startCallPath: 通話開始ボタンが押されたときのリクエスト先
//   - config.finishPath: 発信キャンセル/通話終了ボタンが押されたときのリクエスト先
export function setup(config) {
  // 発信音のAudioオブジェクト
  let calling_audio;

  const START_CALL_PATH = config.startCallPath;
  const FINISH_PATH = config.finishPath;

  const CSS_CLASSES = {
    startCall: "js-calling-start-call",
    cancel: "js-calling-cancel",
    finish: "js-calling-finish",
    pend: "js-calling-pend"
  };

  const SELECTORS = {
    startCall: `.${CSS_CLASSES.startCall}`,
    cancel: `.${CSS_CLASSES.cancel}`,
    finish: `.${CSS_CLASSES.finish}`,
    pend: `.${CSS_CLASSES.pend}`,
    topBar: ".js-top-notice-bar-message",
    navigationLink: ".thread-nav-link",
    disabledLayerUnderCallingInfo: "#full-screen-disabled-layer-under-top-notice-bar"
  };

  const xhrCache = {};

  $(document).on("click", SELECTORS.startCall, onStartCallButtonClick);
  $(document).on("click", SELECTORS.cancel, skyway.finish);
  $(document).on("click", SELECTORS.finish, onFinishButtonClick);
  $(document).on("demand_call:update", onDemandCallUpdate);
  $(window).on("beforeunload", onWindowBeforeUnload);

  function onStartCallButtonClick() {
    if (calling_audio == null) {
      // iOS Safari ではユーザーアクション（クリックなど）がトリガーになってないと
      // Audioを読み込めないのでここで実行する。（加えて、同一の Audio オブジェクトは１回しか再生できない）
      // https://webfrontend.ninja/js-audio-autoplay-policy-and-delay/
      calling_audio = new Audio(config.callingAudioAssetPath);
    }

    if ($findStartCallButton().attr("disabled")) {
      return;
    }

    disableStartCallButton();
    skyway.startCall({
      onOpen: (peerId) => {
        if (sendStartCallRequest(peerId)) {
          toggleCallingInfo({ state: "calling" });
          toggleNavigationLinks({ state: "calling" });
          putDisabledLayerUnderCallingInfo();
        } else {
          skyway.finish();
        }
      },
      onStream: () => {
        toggleCallingInfo({ state: "talking" });
        toggleNavigationLinks({ state: "talking" });
        removeDisabledLayerUnderCallingInfo();
      },
      onClose: () => {
        sendFinishRequest();
        toggleCallingInfo({ state: "finished" });
        toggleNavigationLinks({ state: "finished" });
        enableStartCallButton();
        removeDisabledLayerUnderCallingInfo(); 
      },
      onError: (error) => {
        let errorMessage =
          "システムエラーです。お手数ですが、時間をおいて再度お試しください。";

        if (error instanceof skyway.MicrophonePermissionDeniedError) {
          errorMessage = error.message;
        }

        util_showMessageIntoTopBar(errorMessage, "danger", false);
        enableStartCallButton();
        removeDisabledLayerUnderCallingInfo();
      },
    });
  }

  function sendStartCallRequest(peerId) {
    const type = "POST";
    const url = START_CALL_PATH;
    const params = { peer_id: peerId };
    const dataType = "json";

    // 発信のリクエストは同期的に行う。非同期に行うと、「プルルルル……」という発信音も同時に鳴り始める。結果、発信直後
    // に混雑等で切断された場合に発信音が「プッ」と一瞬だけ聞こえて違和感が強い。発信のリクエストが成功して初めて発信音
    // を鳴らすことで問題を回避している。
    const options = { async: false };

    const xhr = util_execAjaxWithNoCallback(
      type,
      url,
      params,
      dataType,
      options
    );

    // リクエストが成功した場合: resolved
    // リクエストが失敗した場合: rejected
    if (xhr.state() !== "resolved") {
      return false;
    }

    // 発信処理に成功した場合: calling
    // 発信処理に失敗した場合: finished
    return xhr.responseJSON?.state === "calling";
  }

  // 発信/通話の切断リクエストを送信する。すでに送信済みの場合は何もしない。
  function sendFinishRequest() {
    if (xhrCache.finish) {
      return;
    }

    const params = {};
    const doneCallback = () => (xhrCache.finish = null);

    xhrCache.finish = util_execAjaxWithSuccessCallback(
      "post",
      FINISH_PATH,
      params,
      "json",
      doneCallback
    );
  }

  function toggleCallingInfo({ state }) {
    if (calling_audio != null) {
      // ステータス変更時に発信音をかならず一時停止する
      calling_audio.pause();
    }

    switch (state) {
      case "calling": {
        util_showMessageWithButtonIntoTopBar({
          message: "発信中...",
          alertCssClass: "warning",
          buttonText: "発信をキャンセル",
          buttonCssClass: CSS_CLASSES.cancel,
        });
        if (calling_audio != null) {
          // 発信音を再生する
          calling_audio.loop = true; // ループ
          calling_audio.currentTime = 0; // 頭出し
          calling_audio.volume = 0.3; // 音量（0-1.0)
          calling_audio.play();
        }
        break;
      }
      case "talking": {
        $findFinishButton().closest(SELECTORS.topBar).remove();
        $findCancelButton().closest(SELECTORS.topBar).remove();
        util_showMessageWithButtonIntoTopBar({
          message: "通話中...",
          alertCssClass: "danger",
          buttonText: "通話を終了する",
          buttonCssClass: CSS_CLASSES.finish,
        });
        break;
      }
      case "pending": {
        $findFinishButton().closest(SELECTORS.topBar).remove();
        util_showMessageWithButtonIntoTopBar({
          message: "保留中...",
          alertCssClass: "info",
          buttonText: "通話を終了する",
          buttonCssClass: CSS_CLASSES.finish,
        });
        break;
      }
      default: {
        $findCancelButton().closest(SELECTORS.topBar).remove();
        $findFinishButton().closest(SELECTORS.topBar).remove();
      }
    }
  }

  function toggleNavigationLinks({ state }) {
    for (const link of $(SELECTORS.navigationLink)) {
      const $link = $(link);

      switch (state) {
        case "calling":
        case "talking": {
          // 一度有効化する。無効化処理が重複しないように。
          enableLink($link);

          disableLink($link);
          break;
        }
        case "finished": {
          enableLink($link);
          break;
        }
      }
    }

    function enableLink($link) {
      $link.off("click.calling.toggleNavigationLinks");
    }

    function disableLink($link) {
      $link.on("click.calling.toggleNavigationLinks", () => {
        // ここでは発信中と通話中を区別していない。利用者もそこまで細かく区別しているとは思えないため。
        alert("通話中はご利用いただけません。");
        return false;
      });
    }
  }

  function onFinishButtonClick() {
    const confirmation = "通話中です。\n終了してもよろしいですか？";

    if (!confirm(confirmation)) {
      return false;
    }

    skyway.finish();
  }

  function onDemandCallUpdate(_, demandCallAttrs) {
    if (["finished", "disconnected_and_unfinished"].includes(demandCallAttrs.state)) {
      skyway.finish();
    }

    if (demandCallAttrs.state === "pending") {
      toggleCallingInfo({ state: "pending" });
      toggleNavigationLinks({ state: "pending" });
    }
  }

  function onWindowBeforeUnload() {
    const $cancelButton = $findCancelButton();

    if ($cancelButton.length > 0) {
      // ウィンドウがアンロードされる際、発信中だったら強制的にキャンセルする。事案通話が不正な状態で残るのを防ぐため。
      sendFinishRequest();
      skyway.finish();
    }

    const $finishButton = $findFinishButton();

    if ($finishButton.length > 0) {
      // ウィンドウがアンロードされる際、通話中だったら強制的に通話を終了する。事案通話が不正な状態で残るのを防ぐため。
      sendFinishRequest();
      skyway.finish();
    }
  }

  function enableStartCallButton() {
    $findStartCallButton().attr({ disabled: false });
  }

  function disableStartCallButton() {
    // jQuery.fn.prop() ではCSSの [disabled] を反映できないため attr() を使っている。
    $findStartCallButton().attr({ disabled: true });
  }

  function $findStartCallButton() {
    return $(SELECTORS.startCall);
  }

  function $findCancelButton() {
    return $(SELECTORS.cancel);
  }

  function $findFinishButton() {
    return $(SELECTORS.finish);
  }

  function putDisabledLayerUnderCallingInfo() {
    $(SELECTORS.disabledLayerUnderCallingInfo).fadeIn(50)
  }

  function removeDisabledLayerUnderCallingInfo() {
    $(SELECTORS.disabledLayerUnderCallingInfo).fadeOut(50)
  }

}
